import { render, staticRenderFns } from "./ClipBoard.vue?vue&type=template&id=dc1813a4"
import script from "./ClipBoard.vue?vue&type=script&lang=js"
export * from "./ClipBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports